import { useForm, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import "./Form.css"
import image from "../Images/New Project.png"
export default function Form() {

  const {
    register,
    watch,
    formState: { errors },
  } = useForm()

  const { control, handleSubmit } = useForm();

  const Navigate = useNavigate()

  const onSubmit = async (data) => {
    console.log(data)
    // const url = data.YourWebsite;
    
    const url = data.YourWebsite; // Replace with the desired URL
    const encodedUrl = encodeURIComponent(url);
    Navigate(`/detail/${encodedUrl}`)

  }


  console.log(watch("YourWebsite")) // watch input value by passing the name of it


  return (
    <div className='FormContainer'>
      <div style={{marginBottom:"120px"}}>
        <img src={image} style={{height:"250px"}} alt="mohrek"></img>
      </div>
    <form onSubmit={handleSubmit(onSubmit)} style={{display:"flex",direction:"rtl"}}>
      {/* register your input into the hook by invoking the "register" function */}
      <div style={{ display: 'flex', alignItems: 'center',width:"100%"}}>
        <Controller
          name="YourWebsite"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
            color="success"
             focused
            InputProps={{
                style: { color: 'white',textAlign:"right" }, // Change the text color here
              }}
              {...field}
              label="YourWebsite"
            //   variant="outlined"
              fullWidth
              margin="normal"
              placeholder='Like... https://example.com'
            />
          )}
        />
        <Button style={{height:"50px",marginRight:"5px",marginTop:"8px",
        width:"150px",backgroundColor:"rgb(78, 181, 76)",fontSize:"17px"}} variant="contained" type="submit">
            تحقق من موقعك
        </Button>
      </div>
    </form>
    </div>
  )
}